<template>
  <div class="my-4">
     <div class="row mt-3">
      <div class="col-md-2">
        <date-picker
          id="startDatePicker"
          class=""
          v-model="range.startDate"
          :config="datePickerConfig"
          placeholder="Start Date"
        ></date-picker>
      </div>
      <div class="col-md-2">
        <date-picker
          id="endDatePicker"
          class=""
          v-model="range.endDate"
          :config="datePickerConfigEndDate"
          placeholder="End Date"
        ></date-picker>
      </div>
      <!-- <div class="col-md-2">
        <select v-model="client" class="form-control">
          <option :value="false" selected>
            {{ $t("lang.button.all") }}
          </option>
          <option v-for="(team, index) in groups" :value="team.id" :key="index">
            {{ team.name }}
          </option>
        </select>
      </div> -->
      <div class="col-md-2">
        <treeselect
          @input="filterTypeChanged"
          v-model="filters.type"
          :options="optselect"
          :multiple="true"
        >
        </treeselect>
      </div>

      <!-- <div class="col-md-2"> 
          <treeselect
            v-model="filters.sendingMethods"
            :options="sendingMethods"
            :multiple="true"

          >
          </treeselect>
      </div>

      <div class="col-md-2">
          <treeselect
            v-model="filters.sendingProviders"
            :options="sendingProviders"
            :multiple="true"

          >
          </treeselect>
      </div> -->

      <div class="col-md-2">
        <button
          class="btn btn-success"
          :disabled="loadingStats"
          @click="loadRangeStats()"
        >
          <i class="icon-calendar-check-o mr-2"></i>
          <small>
            {{ $t("lang.label.letsgetstarted") }}
          </small>
        </button>
      </div>

     </div>

    <div class="mt-3" v-if="openchart">
      <button
          class="btn btn-outline-primary"
          :class="timechart == 'day' ? 'active' : ''"
          @click="changeChart('day')"
        >
          <small>
            {{ $t("lang.label.days") }}
          </small>
        </button>
        <button
          class="btn btn-outline-primary ml-2"
          :class="timechart == 'week' ? 'active' : ''"
          @click="changeChart('week')"
        >
          <small>
            {{ $t("lang.label.weeks") }}
          </small>
        </button>
        <button
          class="btn btn-outline-primary ml-2"
          :class="timechart == 'month' ? 'active' : ''"
          @click="changeChart('month')"
        >
          <small>
            {{ $t("lang.label.months") }}
          </small>
      </button>

      <LoadingSpinner v-if="loadingStats" />

      <div v-if="!loadingStats" style="overflow: scroll">
              <div class="row" v-if="false">
                <div class="col-12">
                  <line-chart
                    :class="timechart == 'day' ? 'd-block' : 'd-none'"
                    :width="300"
                    :height="400"
                    :chart-data="groupedmeetigns"
                    :options="groupedmeetigns.options"
                  />

                  <line-chart
                    v-if="timechart == 'week'"
                    :width="300"
                    :height="400"
                    :chart-data="groupedmeetignsweek"
                    :options="groupedmeetignsweek.options"
                  />

                  <line-chart
                    v-if="timechart == 'month'"
                    :width="300"
                    :height="400"
                    :chart-data="groupedmeetignsmonth"
                    :options="groupedmeetignsmonth.options"
                  />
                </div>
              </div>

              <div style="min-width: 800px">
                <line-chart
                  :class="timechart == 'week' ? 'd-block' : 'd-none'"
                  v-if="multiaxisweek.datasets.length > 0"
                  :width="300"
                  :height="100"
                  :chart-data="multiaxisweek"
                  :options="multiaxisweek.options"
                />
                <line-chart
                  :class="timechart == 'day' ? 'd-block' : 'd-none'"
                  v-if="multiaxis.datasets.length > 0"
                  :width="300"
                  :height="100"
                  :chart-data="multiaxis"
                  :options="multiaxis.options"
                />
                <line-chart
                  :class="timechart == 'month' ? 'd-block' : 'd-none'"
                  v-if="multiaxismonth.datasets.length > 0"
                  :width="300"
                  :height="100"
                  :chart-data="multiaxismonth"
                  :options="multiaxismonth.options"
                />
              </div>
      </div>
    </div>
  </div>
</template>

<script>

import moment from "moment";
import LineChart from "@/components/Chart.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Treeselect from "@riophae/vue-treeselect";
import { mapState, mapActions } from 'vuex';

export default {
  name: 'GraphOfStats',
  components: {
    Treeselect, LoadingSpinner, LineChart
  },
  props: {
    targetId: {
      default: null,
      required: false
    }
  },
  data() {
    return {
      openchart: false,
      timechart: "day",
      client: false,
      groups: [],
      optselect: [],
      sendingMethods: [
        {
          id: "method_nylas",
          label: "API Nylas",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,0,100",
        },
        {
          id: "method_oliver",
          label: "API Oliverlist",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,0,100",
        },
        {
          id: "method_smtp",
          label: "SMTP ",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,0,100",
        },
      ],
      sendingProviders: [
        {
          id: "ews",
          label: "Outlook",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,0,100",
        },
        {
          id: "gmail",
          label: "Gmail",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,0,100",
        },
      ],
      options: [
        {
          id: "sent",
          label: "Sent",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,79,118",
        },
        {
          id: "bounce_total",
          label: "Bounces",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "220,0,4",
        },
        {
          id: "scheduled",
          label: "Scheduled",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,222,33",
        },
        {
          id: "bounce_target",
          label: "Bounce Target",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,222,33",
        },
        {
          id: "accounts_sent",
          label: "Mailbox",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "105,200,0",
        },
        {
          id: "newsent",
          label: "New Sent",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,0",
        },
        {
          id: "recurringsent",
          label: "Recurring Sent",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,0,0",
        },
        {
          id: "recurringsent2",
          label: "Step 2",
          role: ["1"],
          isDisabled: false,
          color: "180,140,30",
        },
        ,
        {
          id: "recurringsent3",
          label: "Step 3",
          role: ["1"],
          isDisabled: false,
          color: "210,230,20",
        },
        ,
        {
          id: "recurringsent4",
          label: "Step 4",
          role: ["1"],
          isDisabled: false,
          color: "180,200,30",
        },
        ,
        {
          id: "recurringsent5",
          label: "Step 5",
          role: ["1"],
          isDisabled: false,
          color: "180,130,30",
        },
        ,
        {
          id: "recurringsent6",
          label: "Step 6",
          role: ["1"],
          isDisabled: false,
          color: "230,230,120",
        },
        {
          id: "money",
          label: "CA TTC",
          role: ["1"],
          isDisabled: false,
          color: "43, 199, 0",
        },
        {
          id: "billing",
          label: this.$t("lang.statistics.billing"),
          role: ["1", "5", "6", "7"],
          isDisabled: false,
          color: "28, 4, 219",
        },
        {
          id: "meetings",
          label: this.$t("lang.statistics.generated"),
          role: ["4", "1", "5", "6", "7"],
          isDisabled: false,
          color: "51, 204, 204",
        },
        {
          id: "cashed",
          label: this.$t("lang.statistics.cashed"),
          role: ["1"],
          isDisabled: false,
          color: "122, 169, 81",
        },
        {
          id: "sessions",
          label: this.$t("lang.statistics.session"),
          role: ["1"],
          isDisabled: false,
          color: "45, 138, 131",
        },
        {
          id: "response_rate",
          label: "MAR (Manual Answer Rate)",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,0",
        },
        {
          id: "conversion_rate",
          label: "Converstion rate",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,0",
        },
        {
          id: "variance",
          label: "Standard Deviation",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "0,0,0"
        },
        // {
        //   id: "spam_rate",
        //   label: "Spam rate",
        //   role: ["1", "5", "6"],
        //   isDisabled: false,
        //   color: "255,100,0",
        // },
        // SPAM CHECK DELIVERABILITY
        {
          id: "spam_check_deliver_prc",
          label: "SPAM CHECK DELIVERAVILTY",
          role: ["1"],
          isDisabled: false,
          color: "195, 226, 194",
          isRate: true,
          format: "float",
        },
      ],
      filters: {
        type: [],
        sendingMethods: [],
        sendingProviders: [],
      },
      teamgroups: [],
      datePickerConfig: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        // minDate: moment().startOf("day")
        maxDate: moment().endOf("day"),
      },
      datePickerConfigEndDate: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        maxDate: moment().endOf("day"),
      },
      range: {
        startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      groupedmeetignsmonth: {
        labels: [],
        datasets: [
          {
            type: "bar",
            label: "Data One",
            backgroundColor: "#52BE80",
            data: [],
          },
          {
            type: "bar",
            label: "Data Two",
            backgroundColor: "#dc3545",
            data: [],
          },
          {
            type: "bar",
            label: "Data Three",
            backgroundColor: "#ffc107",
            data: [],
          },
        ],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 1,
                time: {
                  unit: "month",
                  displayFormats: {
                    month: "M YYYY",
                  },
                },
              },
            ],
            yAxes: [
              {
                type: "linear",
                stacked: true,
                id: "y2",
                min: 0,
                max: 100,
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                  stepSize: 10,
                  min: 0,
                  max: 100,
                },
              },
            ],
          },
        },
      },
      groupedmeetignsweek: {
        labels: [],
        datasets: [
          {
            type: "bar",
            label: "Data One",
            backgroundColor: "#52BE80",
            data: [],
          },
          {
            type: "bar",
            label: "Data Two",
            backgroundColor: "#dc3545",
            data: [],
          },
          {
            type: "bar",
            label: "Data Three",
            backgroundColor: "#ffc107",
            data: [],
          },
        ],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 1,
                time: {
                  unit: "week",
                  displayFormats: {
                    week: "W YYYY",
                  },
                },
              },
            ],
            yAxes: [
              {
                type: "linear",
                stacked: true,
                id: "y2",
                min: 0,
                max: 100,
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                  stepSize: 10,
                  min: 0,
                  max: 100,
                },
              },
            ],
          },
        },
      },
      groupedmeetigns: {
        labels: [],
        datasets: [
          {
            type: "bar",
            label: "Data One",
            backgroundColor: "#52BE80",
            data: [],
          },
          {
            type: "bar",
            label: "Data Two",
            backgroundColor: "#dc3545",
            data: [],
          },
          {
            type: "bar",
            label: "Data Three",
            backgroundColor: "#ffc107",
            data: [],
          },
        ],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 1,
                time: {
                  unit: "day",
                },
              },
            ],
            yAxes: [
              {
                type: "linear",
                stacked: true,
                id: "y2",
                min: 0,
                max: 100,
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                  stepSize: 10,
                  min: 0,
                  max: 100,
                },
              },
            ],
          },
        },
      },
      multiaxismonth: {
        labels: [],
        datasets: [
          {
            type: "bar",
            label: "Meetings",
            borderColor: "RGB(133,43,242,1)",
            backgroundColor: "RGBA(133,43,242,0.51)",
            pointBackgroundColor: "rgba(220,220,220,1)",
            yAxisID: "y2",
            data: [],
          },
        ],
        options: {
          responsive: true,
          title: {
            display: true,
            text: this.$t("lang.label.activity"),
          },
          scales: {
            yAxes: [
              {
                type: "linear",
                id: "y1",
                position: "right",
                display: true,
                gridLines: {
                  drawOnChartArea: false,
                },
                ticks: {
                  beginAtZero: true,
                },
              },
              {
                type: "linear",
                id: "y2",
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            xAxes: [
              {
                type: "time",
                time: {
                  unit: "month",
                },
                stacked: false,
                offset: true,
                gridLines: {
                  display: false,
                },
              },
            ],
          },
        },
      },
      multiaxisweek: {
        labels: [],
        datasets: [
          {
            type: "bar",
            label: "Meetings",
            borderColor: "RGB(122,43,242,1)",
            backgroundColor: "RGBA(133,23,242,0.51)",
            pointBackgroundColor: "rgba(110,220,220,1)",
            yAxisID: "y2",
            data: [],
          },
        ],
        options: {
          responsive: true,
          title: {
            display: true,
            text: this.$t("lang.label.activity"),
          },
          scales: {
            yAxes: [
              {
                type: "linear",
                id: "y1",
                position: "right",
                display: true,
                gridLines: {
                  drawOnChartArea: false,
                },
                ticks: {
                  beginAtZero: true,
                },
              },
              {
                type: "linear",
                id: "y2",
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            xAxes: [
              {
                type: "time",
                time: {
                  unit: "week",
                  displayFormats: {
                    week: "W YYYY",
                  },
                },
                offset: true,
                gridLines: {
                  display: true,
                },
              },
            ],
          },
        },
      },
      multiaxis: {
        labels: [],
        datasets: [],
        options: {
          responsive: true,
          title: {
            display: true,
            text: this.$t("lang.label.activity"),
          },
          scales: {
            yAxes: [
              {
                type: "linear",
                id: "y1",
                position: "right",
                display: true,
                gridLines: {
                  drawOnChartArea: false,
                },
                ticks: {
                  beginAtZero: true,
                },
              },
              {
                type: "linear",
                id: "y2",
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            xAxes: [
              {
                type: "time",
                time: {
                  unit: "day",
                },
                stacked: false,
                offset: true,
                gridLines: {
                  display: false,
                },
              },
            ],
          },
        },
      },
    };
  },
  created() {
    this.options.forEach((r, index) => {
      if (r.role.indexOf(this.currentUser.role_id) >= 0) {
        if (r.isDisabled) {
          r.label = r.label + " (coming soon)";
        }
        this.optselect.push(r);
        if (r.id == "meetings") {
          this.filters.type.push(r.id);
        }
      }
    });
    // Por defecto: sent y newsent seleccionados y búsqueda aplicada
    this.filters.type = ["sent", "newsent"];
    this.$nextTick(() => {
      this.loadRangeStats();
    });
  },
  computed: {
   ...mapState({
      currentUser: (state) => state.authentication.user,
      loadingStats: (state) => state.campaigns.loadingStats,
      stats: (state) => state.campaigns.stats.data,
      clientId: (state) => state.onboarding.client_id
    }),
  },
  watch: {
    loadingStats: function () {
      this.loadStatsData();
    },
  },
  methods: {
    ...mapActions("campaigns", {
      getCampaignStatsByIdAndRange: "getStatsByIdAndRange",
    }),
    filterTypeChanged() {
      if (this.includeOption("billing")) {
        this.filters.sendingMethods = [];
        this.filters.sendingProviders = [];
      }
    },
    loadRangeStats() {
      if (
        this.filters.type.indexOf("recurringsent") >= 0 &&
        this.filters.type.indexOf("recurringsent2") < 0
      ) {
        this.filters.type.push("recurringsent2");
        this.filters.type.push("recurringsent3");
        this.filters.type.push("recurringsent4");
        this.filters.type.push("recurringsent5");
        this.filters.type.push("recurringsent6");
        this.optselect.push(this.options["recurringsent2"]);
        this.optselect.push(this.options["recurringsent3"]);
        this.optselect.push(this.options["recurringsent4"]);
        this.optselect.push(this.options["recurringsent5"]);
        this.optselect.push(this.options["recurringsent6"]);
      }

      this.multiaxis.datasets = [];
      this.multiaxisweek.datasets = [];
      this.multiaxismonth.datasets = [];
      this.loadMultiaxis();
      this.meetings_details = [];
      this.openlist = false;
      this.openchart = true;
      if (this.validarDate() === true) {
        this.$swal({
          type: "warning",
          title: "Error!",
          text: "Start date should be less than end date. ",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Close",
        });
      } else {
        const filters = [
          ...this.filters.type,
          ...this.filters.sendingMethods,
          ...this.filters.sendingProviders,
        ];
        // if(this.sendingProvider.length > 0) this.filters.type.push(...this.filters2 );
        // if(this.sendingMethods.length > 0) this.filters.type.push(...this.filters3 );
        this.getCampaignStatsByIdAndRange({
          id: this.selCampaignId != undefined ? this.selCampaignId : 0,
          startDate: this.range.startDate,
          endDate: this.range.endDate,
          client: this.clientId,
          targetId: this.targetId,
          filters: filters, // this.filters.type,
        });
      }
    },
    loadMultiaxis() {
      this.options.forEach((r, index) => {
        if (this.filters.type.indexOf(r.id) >= 0) {
          let type = "bar";
          let yaxis = "y2";

          if (r.id == "answers") {
            yaxis = "y1";
          }

          if (r.id == "meetings") {
            type = "line";
            yaxis = "y1";
          }
          if (r.id == "reprogramming") {
            type = "line";
            yaxis = "y1";
          }
          if (
            r.id == "recurringsent" ||
            r.id == "recurringsent2" ||
            r.id == "recurringsent3" ||
            r.id == "recurringsent4" ||
            r.id == "recurringsent5" ||
            r.id == "recurringsent6"
          ) {
           // console.log('this.options...', this.options);
            this.multiaxis.datasets.push({
              type: "bar",
              label: r.label,
              filter: r.id,
              yAxisID: "y2",
              backgroundColor: "RGBA(" + r.color + ",0.48)",
              data: [],
            });
            this.multiaxis.options.scales.xAxes = [
              {
                stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 1,
              },
            ];
          } else {
            this.multiaxis.datasets.push({
              type: type,
              label: r.label,
              hidden: false,
              filter: r.id,
              borderColor: "RGBA(" + r.color + ",1)",
              backgroundColor: "RGBA(" + r.color + ",0.48)",
              pointBackgroundColor: "RGBA(" + r.color + ",1)",
              yAxisID: yaxis,
              data: [],
            });
            this.multiaxisweek.datasets.push({
              type: type,
              label: r.label,
              hidden: false,
              filter: r.id,
              borderColor: "RGBA(" + r.color + ",1)",
              backgroundColor: "RGBA(" + r.color + ",0.48)",
              pointBackgroundColor: "RGBA(" + r.color + ",1)",
              yAxisID: yaxis,
              data: [],
            });
            this.multiaxismonth.datasets.push({
              type: type,
              label: r.label,
              hidden: false,
              filter: r.id,
              borderColor: "RGBA(" + r.color + ",1)",
              backgroundColor: "RGBA(" + r.color + ",0.48)",
              pointBackgroundColor: "RGBA(" + r.color + ",1)",
              yAxisID: yaxis,
              data: [],
            });
          }
        }
      });
    },
    loadStatsData() {
      if (!this.loadingStats) {
        //('loadingStats-----------------', this.loadingStats);
        this.multiaxis.labels = this.stats.activity_by_date.labels;
        //console.log('this.multiaxis.labels-----------------', this.multiaxis.labels);
        this.multiaxis.datasets.forEach((r, index) => {
          this.multiaxis.datasets[index].data =
            this.stats.activity_by_date[this.multiaxis.datasets[index].filter];
        });

        this.getMultiaxis();

        this.groupedmeetigns.labels = this.stats.activity_by_date.labels;
        this.groupedmeetigns.datasets[0].label = "Planned %";
        this.groupedmeetigns.datasets[1].label = "Canceled %";
        this.groupedmeetigns.datasets[2].label = "Absent %";
        this.groupedmeetigns.datasets[0].data =
          this.stats.activity_by_date["planned"];
        this.groupedmeetigns.datasets[1].data =
          this.stats.activity_by_date["canceled"];
        this.groupedmeetigns.datasets[2].data =
          this.stats.activity_by_date["absent"];

        this.getGroupWeek();
        this.getGroupMonth();
      }
    },
    getMultiaxisWeek(type) {
      let stats = this.stats;
      if (stats.activity_by_date[type] === undefined) {
        return;
      }
      let meetings = stats.activity_by_date[type];
      let labels = stats.activity_by_date.labels;
      let newlabels = [];
      let indexof;
      let days = "";
      let day = "";
      let resmeetings = [];
      let reflabelmeeting = [];
      let datescols = [];

      if (labels !== null && labels !== undefined && labels.length > 0) {
        labels.forEach((r, index) => {
          let days = r.split("-");
          let day = new Date(days[0], days[1] - 1, days[2]);

          var d = new Date(
            Date.UTC(day.getFullYear(), day.getMonth(), day.getDate())
          );
          var dayNum = d.getUTCDay() || 7;
          d.setUTCDate(d.getUTCDate() + 4 - dayNum);
          var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
          var week = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);

          if (days[1] + "-" + days[2] == "01-01") {
            week = 1;
          }
          if (days[1] + "-" + days[2] == "01-02") {
            week = 1;
          }

          var refd = day.getFullYear() + " Semana: " + week;

          if (reflabelmeeting.indexOf(refd) < 0) {
            datescols.push(day);
            reflabelmeeting.push(refd);
          }
          indexof = reflabelmeeting.indexOf(refd);
          if (
            newlabels[indexof] == undefined &&
            meetings[index] !== undefined
          ) {
            newlabels[indexof] = 0 + parseInt(meetings[index]);
          } else {
            newlabels[indexof] =
              parseInt(newlabels[indexof]) + parseInt(meetings[index]);
          }
        });
      }

      if (
        newlabels !== null &&
        newlabels !== undefined &&
        newlabels.length > 0
      ) {
        newlabels.forEach((quantity, index) => {
          resmeetings.push(quantity);
        });
        this.multiaxisweek.labels = datescols;

        this.multiaxis.datasets.forEach((r, index) => {
          if (r.filter == type) {
            this.multiaxisweek.datasets[index].data = resmeetings;
          }
        });
      }
    },
    getMultiaxis() {
      this.optselect.forEach((r, index) => {
        this.getMultiaxisMonth(r.id);
        this.getMultiaxisWeek(r.id);
      });
    },
    getMultiaxisMonth(type) {
      let stats = this.stats;

      if (stats.activity_by_date[type] === undefined) {
        return;
      }

      let meetings = stats.activity_by_date[type];
      let labels = stats.activity_by_date.labels;
      let newlabels = [];
      let indexof;
      let days = "";
      let day = "";
      let resmeetings = [];
      let reflabelmeeting = [];
      let datescols = [];

      labels.forEach((r, index) => {
        let days = r.split("-");
        day = new Date(days[0], days[1] - 1, days[2]);
        var refd = day.getFullYear() + "-" + days[1];
        if (reflabelmeeting.indexOf(refd) < 0) {
          reflabelmeeting.push(refd);
        }
        indexof = reflabelmeeting.indexOf(refd);
        if (newlabels[indexof] == undefined && meetings[index] !== undefined) {
          newlabels[indexof] = 0 + parseInt(meetings[index]);
        } else {
          newlabels[indexof] =
            parseInt(newlabels[indexof]) + parseInt(meetings[index]);
        }
      });

      newlabels.forEach((quantity, index) => {
        resmeetings.push(quantity);
      });

      this.multiaxismonth.labels = reflabelmeeting;
      this.multiaxis.datasets.forEach((r, index) => {
        if (r.filter == type) {
          this.multiaxismonth.datasets[index].data = resmeetings;
        }
      });
    },
    changeChart(type) {
      this.timechart = type;
    },
    validarDate() {
      let startDate = new Date(this.range.startDate);
      let endDate = new Date(this.range.endDate);
      if (startDate.getTime() > endDate.getTime()) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.btn-outline-primary.active {
  color: #fff !important;
}
</style>
